var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMilestoneHero5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 326,
    viewBox: "0 0 276 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291.302 181.726C342.314 185.978 378.404 206.547 380.289 228.006C381.329 239.822 372.283 254.931 368.556 261.061C360.44 274.438 350.638 283.137 343.936 288.202C350.928 292.281 353.37 300.693 350.261 306.728C347.896 311.323 342.56 314.107 336.812 313.748C334.299 317.007 330.201 318.631 326.181 317.949C320.153 316.942 317.82 311.353 317.705 311.055C309.738 311.768 302.82 306.816 301.346 300.226C300.265 295.41 302.205 290.185 306.175 286.593C302.78 281.737 303.069 275.439 306.45 271.635C310.654 266.903 319.176 266.596 324.467 272.146C329.67 268.051 337.149 261.128 343.333 250.666C347.644 243.362 351.496 236.623 350.521 231.194C348.264 218.723 319.846 210.799 281.123 210.653C284.511 201.003 287.909 191.354 291.297 181.704L291.302 181.726Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.382 176.857C118.24 209.849 78.1602 220.754 61.669 206.886C52.5915 199.242 48.3404 182.156 46.6462 175.194C42.9564 159.99 43.7547 146.906 44.9267 138.591C37.0886 140.636 29.4351 136.399 27.3687 129.93C25.7951 125.014 27.6085 119.266 31.9391 115.462C31.423 111.378 33.1785 107.344 36.5015 104.982C41.4898 101.445 47.0784 103.748 47.3735 103.874C52.5043 97.7427 60.9103 96.3695 66.6078 99.9998C70.775 102.654 73.094 107.714 72.8036 113.064C78.6415 114.109 82.8759 118.778 83.1619 123.851C83.5236 130.174 77.7041 136.405 70.032 136.204C69.2377 142.774 68.8226 152.954 71.8273 164.743C73.9299 172.958 75.9492 180.457 80.4811 183.606C90.8804 190.847 116.605 176.406 144.134 149.175C148.545 158.408 152.949 167.63 157.36 176.863L157.382 176.857Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.951 125.54C70.8303 124.947 67.7495 123.131 65.8239 119.299C63.7016 115.08 64.3565 111.135 64.6005 109.947",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.951 125.54C70.8303 124.947 67.7495 123.131 65.8239 119.299C63.7016 115.08 64.3565 111.135 64.6005 109.947",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3675 126.66L31.9387 115.463",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.953 119.953L47.3769 103.875",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8026 113.065L67.4676 118.252",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M244.484 214.082C255.772 249.671 285.965 266.647 306.934 259.966C320.523 255.634 332.083 240.802 331.753 226.254C331.277 205.453 306.437 183.526 271.094 185.576C262.224 195.078 253.354 204.58 244.484 214.082Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M277.13 182.322C311.884 195.958 344.085 183.19 352.1 162.68C357.295 149.402 353.037 131.072 341.53 122.18C325.079 109.452 292.393 114.952 271.739 143.701C273.533 156.574 275.336 169.449 277.13 182.322Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M272.402 137.888C304.756 119.255 314.888 86.1359 303.875 67.0719C296.743 54.7191 279.771 46.6022 265.635 50.0344C245.423 54.9439 229.31 83.8947 238.869 117.988C250.05 124.626 261.23 131.263 272.402 137.888Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M234.675 108.107C236.643 70.8192 214.369 44.302 192.38 43.17C178.139 42.4378 162.089 52.2523 157.279 65.98C150.399 85.6108 165.918 114.888 199.727 125.416C211.374 119.642 223.028 113.88 234.675 108.107Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.342 131.975C167.846 102.187 133.717 96.2344 116.167 109.523C104.798 118.136 98.842 135.973 103.999 149.573C111.372 169.02 142.106 181.429 174.749 167.718C179.943 155.803 185.148 143.89 190.342 131.975Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M179.763 174.401C142.743 169.594 114.59 189.777 111.784 211.617C109.964 225.756 118.531 242.509 131.846 248.358C150.896 256.715 181.271 243.48 194.346 210.571C189.483 198.51 184.617 186.46 179.763 174.401Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M202.276 206.624C176.696 233.814 176.57 268.45 192.633 283.516C203.029 293.272 221.622 296.144 234.16 288.77C252.09 278.222 259.146 245.854 240.133 215.981C227.514 212.862 214.895 209.743 202.276 206.624Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M213.467 221.79C183.275 215.077 164.241 185.159 170.955 154.967C177.668 124.775 207.586 105.741 237.778 112.454C267.97 119.168 287.004 149.085 280.291 179.278C273.578 209.47 243.66 228.504 213.467 221.79Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M158.569 139.454C161.714 125.309 175.73 116.392 189.874 119.537C204.019 122.682 212.936 136.698 209.791 150.843L208.762 155.472C205.617 169.617 191.601 178.534 177.456 175.389C163.311 172.244 154.394 158.228 157.539 144.083L158.569 139.454Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.867 161.876C171.499 160.46 167.968 151.974 169.981 142.922C171.994 133.869 178.788 127.679 185.156 129.095C191.524 130.511 195.054 138.997 193.041 148.049C191.029 157.102 184.235 163.292 177.867 161.876Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M190.148 125.025L182.869 137.002L198.461 137.883L190.148 125.025Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M201.493 150.495C204.638 136.35 218.655 127.433 232.799 130.578C246.944 133.723 255.861 147.739 252.716 161.884L251.687 166.514C248.541 180.658 234.525 189.575 220.381 186.43C206.236 183.285 197.319 169.269 200.464 155.124L201.493 150.495Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M220.792 172.916C214.424 171.501 210.893 163.014 212.906 153.962C214.919 144.91 221.713 138.719 228.081 140.135C234.449 141.551 237.979 150.037 235.967 159.089C233.954 168.142 227.16 174.332 220.792 172.916Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M233.074 136.064L225.793 148.051L241.386 148.922L233.074 136.064Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M247.549 125.697L228.551 117.689C224.737 116.082 222.949 111.687 224.556 107.874L225.115 106.547C226.723 102.734 231.117 100.945 234.931 102.553L253.929 110.56C257.743 112.168 259.531 116.562 257.924 120.376L257.364 121.702C255.757 125.516 251.362 127.304 247.549 125.697Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M177.853 94.5044L198.454 95.3015C202.59 95.4615 205.813 98.9436 205.653 103.079L205.597 104.517C205.437 108.653 201.955 111.875 197.819 111.715L177.218 110.918C173.083 110.758 169.86 107.276 170.02 103.141L170.076 101.702C170.236 97.5671 173.718 94.3444 177.853 94.5044Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M194.945 197.359C198.95 200.926 204.035 202.087 207.89 200.237C209.733 199.354 210.943 197.956 211.683 196.808",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneHero5);
export default __webpack_public_path__ + "static/media/milestone-hero5.8c50b5ee850918299dc3e6f64a2c0b8e.svg";
export { ForwardRef as ReactComponent };